import {AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, Input, OnDestroy, OnInit, SkipSelf, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {fadeIn, fadeOut} from 'src/app/animations';
import {BinderClassification, BinderExportFiles} from 'src/app/models/binder/binder-classification.model';
import {BinderContent, BinderDocumentDetails, BinderExpectationTag, BinderResource, BinderTabContent} from 'src/app/models/binder/binder-content.model';
import {TokenHelper} from 'src/app/services/helpers/token.helper';
import {BinderWizardService} from 'src/app/services/sections/binder/binder-wizard.service';
import {GlobalSettingsService} from 'src/app/services/ui/global-settings.service';
import {cloneDeep, sortBy} from 'lodash-es';
import {saveAs} from 'file-saver-es';
import {BinderDetails} from 'src/app/models/binder/binder-details.model';
import moment from 'moment';
import {forkJoin, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {BinderSendDocumentationComponent} from './binder-send-documentation/binder-send-documentation.component';
import {DocViewerDocumentDetails} from '../document-viewer/document-viewer.component';
import {BinderQRScanHistory} from 'src/app/models/binder/binder-QR-scan-history.model';
import {BinderQrScanHistoryComponent} from './binder-qr-scan-history/binder-qr-scan-history.component';
import {EditBinderComponent} from './edit-binder/edit-binder.component';
import {JobLogbook} from 'src/app/models/my-work/job-logbook.model';
import {MatDatepicker} from '@angular/material/datepicker';
import {OverlayOutsideClickDispatcher} from '@angular/cdk/overlay';
import {GenericModalComponent} from '../generic-modal/generic-modal.component';
import {GlobalUtilsService} from 'src/app/services/ui/global-utils.service';
import {BinderFilter} from 'src/app/models/binder/binder-filter.model';
import {ReadingMeasurement} from 'src/app/models/binder/binder-reading-measurement.model';
import {BinderDocumentType} from 'src/app/models/binder/binder-documentType-model';
import {NormalizationFieldExceptionCriteria} from 'src/app/models/normalization-field-exception-criteria.model';
import {ReadingDataType} from 'src/app/models/enum/readingDataType.enum';
import {NormalizationFieldExceptionCriteriaDataType} from 'src/app/models/enum/normalizationField-exception-criteria-dataType.enum';
import {MatSelectChange} from '@angular/material/select';
import { BaseBinderWizardService } from 'src/app/services/interfaces/base-binder-wizard-service';
import { BinderSessionWizardService } from 'src/app/services/sections/binder/binder-session-wizard.service';

@Component({
	selector: "virtual-binder",
	templateUrl: "./virtual-binder.component.html",
	styleUrls: [
		"./virtual-binder.component.scss",
		"../stylesheets/job-actions.scss",
		"../stylesheets/job-main.scss",
		"../stylesheets/job-inputs.scss",
		"../stylesheets/forms-container.scss",
	],
	animations: [fadeIn(200), fadeOut(200)],
	
})
export class VirtualBinderComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild('sendDocumentation', { static: true }) public sendDocumentation: BinderSendDocumentationComponent;
	@ViewChild('qrScanHistory', { static: true }) public qrScanHistory: BinderQrScanHistoryComponent;
	@ViewChild('editBinder', { static: true }) public editBinder: EditBinderComponent;
	@ViewChild('filterModal', { static: true }) public filterModal: GenericModalComponent;
	@ViewChild('binderRequestAccess', { static: true }) public binderRequestAccess: GenericModalComponent;
	@ViewChild('binderExportFilesWarning', { static: true }) public binderExportFilesWarning: GenericModalComponent;

	@ViewChild(MatDatepicker) datePicker: MatDatepicker<Date>;

	constructor(
		private activatedRoute: ActivatedRoute,
		@SkipSelf() private binderService: BaseBinderWizardService,
		private cdRef: ChangeDetectorRef,
		private router: Router,
		private cdkConnectedOverlay: OverlayOutsideClickDispatcher
	) { }

	public binderDetails: BinderDetails;
	public docViewerHeaderReady: boolean = false;
	public binderClassification: BinderClassification[] = [];
	public binderParents: BinderClassification[] = [];
	public selectedBinderChildren: BinderClassification[] = [];
	public binderSetupData: { years: number[] } = { years: [] };
	public binderQRScanHistory: BinderQRScanHistory[] = [];
	public documentTypes: BinderDocumentType[] = [];
	public normalizationFieldExceptionCriterias: NormalizationFieldExceptionCriteria[] = [];
	public readingCriterias: NormalizationFieldExceptionCriteria[] = [];
	public measurementCriteria: any[] = [];
	public serviceCategoryDocumentReadingId: number;
	public readingMeasurements: ReadingMeasurement[] = [];
	public selectedMeasurement: ReadingMeasurement;
	public selectedCriteria: NormalizationFieldExceptionCriteria | null = null;
	public isMeasurementAvailable: boolean;
	public commonReadingsOnly = false;


	public exportBinderFiles: BinderExportFiles;

	public binderParentsCopy: BinderClassification[] = [];

	public hasAddToBinderAccess = false;
	public hasEditBinderAccess = false;
	public hasQRScansAccess = false;
	public hasWorkToDoJob: JobLogbook[] = [];
	public hasBinderUserPermission: boolean;

	public selectedBinder: BinderClassification = null;
	public binderContent: BinderContent;
	public expectationTagsMap: Map<number, BinderExpectationTag[]>
	public returnUrl: string;

	public filterBinderForm: FormGroup;
	public documentAssets: BinderResource[] = [];
	public isFilterOpen: boolean;
	public isBinderFiltered: boolean;
	public minDate: Date = null;
	public maxDate: Date = null;
	public startDate: Date = new Date();
	public filter: { showTabs: true, asset: 0, fromDate: null, toDate: null, documentTypeIds: number[]|null , readingCriteria: null, readingValue: null, readingValueStart: null, readingValueEnd: null};

	public isBinderAndCustomerLegacy: boolean;

	public documentDetailsCache = new Map<
		string,
		{
			documentId?: number;
			documentDownloadName: string;
			documentDisplayName: string;
			downloadDocumentId: number;
			fileName: string;
			content: Blob;
			isLoading?: boolean;
			isNotExisting?: boolean;
			isNotSupported?: boolean;			
			jobId?: number;
			jobDocumentId?: number;	
		}
	>();
	public selectedDocumentDetailsIndex = 0;

	public binderFormGroup: FormGroup;

	public isDropdownMenuOpen = false;
	public isDataLoading = true;
	public isDocumentsLoadingFailed = false;
	public loaderMessage = null;

	public hasCustomerPermissionAIReviewRequired = false;

	public targetEmailAddress: { targetEmail: string };

	public customButtons: any[] = [];
	public prevButton: HTMLButtonElement;
	public nextButton: HTMLButtonElement;
	public downloadButton: HTMLButtonElement;

	public unsubscriber$ = new Subject<void>();

	public readonly self = this;
	public readonly moment = moment;
	public displayServiceContractName: boolean = false;
	public availableTags: BinderExpectationTag[];

	public get selectedDocument() {
		if (this.selectedDocumentDetailsIndex == null) {
			return null;
		}

		const index = this.selectedDocumentDetailsIndex;
		const documentDetails = !!this.selectedBinder.documents[index] ? this.documentDetailsCache.get(
			this.getDocumentUniqueKeyByDocument(this.selectedBinder.documents[index])
		) : null;

		if (!documentDetails || documentDetails.isLoading) {
			return null;
		} else {
			return documentDetails;
		}
	}

	public get minToDate() {
		return this.filterBinderForm.get('fromDate')?.value || this.minDate;
	}

	public get maxFromDate() {
		return this.filterBinderForm.get('toDate')?.value || this.maxDate;
	}

	@HostListener("window:click")
	onGlobalClick(): void {
		this.isDropdownMenuOpen = false;
		this.isFilterOpen = false;
	}
	private isSessionValue = false;
	@Input()
	set isSession(value: boolean) {
	  this.isSessionValue = value;
	}
	get isSession(): boolean {
		return this.isSessionValue;
	}

	ngOnInit(): void {
		GlobalSettingsService.isGlobalHeadingVisible = false;
		this.returnUrl = this.router.url;

		this.binderClassification =
			this.activatedRoute.snapshot.data.binderClassification || [];
		this.binderDetails = this.activatedRoute.snapshot.data.binderDetails || null;
		this.binderSetupData = this.activatedRoute.snapshot.data.binderSetupData || { years: [] };
		this.targetEmailAddress = this.activatedRoute.snapshot.data.binderTargetEmail || { targetEmail: null };
		this.binderQRScanHistory = this.activatedRoute.snapshot.data.binderQRScanHistory || [];
		this.hasQRScansAccess = this.activatedRoute.snapshot.data.hasAccesToQRScans || false;
		this.hasWorkToDoJob = this.activatedRoute.snapshot.data.hasWorkToDo;
		this.isBinderAndCustomerLegacy = this.activatedRoute.snapshot.data.isBinderAndCustomerLegacy || false;
		this.hasCustomerPermissionAIReviewRequired = this.activatedRoute.snapshot.data.hasCustomerPermission || false;
		this.hasBinderUserPermission = this.activatedRoute.snapshot.data.hasBinderUserPermission || false;

		if (this.hasWorkToDoJob?.length === 1 && sessionStorage.getItem('binder-rurl') === null) {
			sessionStorage.setItem('binder-rurl', this.returnUrl);
			this.router.navigate([`/${this.hasWorkToDoJob[0].urlHash}/digital-log`]);
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		} else if ((this.hasWorkToDoJob?.length > 1 || this.hasWorkToDoJob?.length === 0) && sessionStorage.getItem('binder-rurl') === null) {
			sessionStorage.setItem('binder-rurl', this.returnUrl);
			this.router.navigate([`digital-logbooks`], { relativeTo: this.activatedRoute });
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		} else {
			sessionStorage.removeItem('binder-rurl');
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		}

		this.checkAddToBinderAccess();
		this.checkEditBinderAccess();

		sortBy(this.binderClassification, [
			(item: BinderClassification) => item.listOrder,
		]);

		const year = this.binderDetails.isYearless ? null :
			this.binderSetupData.years
				.sort()
				.reverse()
				.find((item) => item <= moment().year()) || moment().year()

		this.binderFormGroup = new FormGroup({
			parent: new FormControl(null),
			child: new FormControl(null),
			year: new FormControl(year)
		});

		this.binderFormGroup.get('readingCriteria')?.valueChanges.subscribe(criteria => {
			this.updateReadingValue(criteria);
		});

		this.binderFormGroup.get("parent").valueChanges.subscribe((parent) => {
			if (
				parent.documents &&
				parent.documents.length > 0 &&
				parent.children.length > 0
			) {
				const defaultChild = { binderClassificationId: 0, binderName: "..." };
				this.selectedBinderChildren = [defaultChild, ...parent.children];
			} else {
				this.selectedBinderChildren = parent.children;
			}

			this.refreshSelection();
		});

		this.binderFormGroup.get("child").valueChanges.subscribe((child) => {
			const parent = this.binderFormGroup.get("parent").value;
			this.selectedBinder =
				(child && child.binderClassificationId !== 0 && child) ||
				parent ||
				null;
			this.loadDocument(0);
		});

		this.binderFormGroup.get("year").valueChanges.subscribe(() => {
			this.filterBinderForm.patchValue(
				{
					showTabs: true,
					asset: this.documentAssets[0].accountSiteResourceId,
					fromDate: null,
					toDate: null,
					documentTypeIds: [],
					readingCriteria: null,
					readingValue: null,
					readingValueStart: null,
					readingValueEnd: null
			});
			this.filter = {
				showTabs: this.filterBinderForm.get('showTabs')?.value,
				asset: this.filterBinderForm.get('asset')?.value,
				fromDate: this.filterBinderForm.get('fromDate')?.value,
				toDate: this.filterBinderForm.get('toDate')?.value,
				documentTypeIds: this.binderFormGroup.get('documentTypeIds')?.value,
				readingCriteria: this.filterBinderForm.get('readingCriteria')?.value,
				readingValue: this.filterBinderForm.get('readingValue')?.value,
				readingValueStart: this.filterBinderForm.get('readingValueStart')?.value,
				readingValueEnd: this.filterBinderForm.get('readingValueEnd')?.value
			};
			this.initBinderSelection();
			this.setFilterDates();
		});

		this.unsubscriber$.subscribe(() => {
			// Remove loading documents on API call cancelling
			// We don't want the document cache to appear as loading if API call is cancelled
			[...this.documentDetailsCache.keys()].forEach((key) => {
				if (!!this.documentDetailsCache.get(key).isLoading) {
					this.documentDetailsCache.delete(key);
				}
			});
		});

		this.initFilterBinderForm();

		this.initBinderSelection();
		this.setFilterDates();

	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			GlobalSettingsService.isGlobalLoaderLoading = false;
		}, 200);
	}

	ngOnDestroy(): void {
		GlobalSettingsService.isGlobalHeadingVisible = true;
	}

	public getDocumentUniqueKey(jobId: number, documentId: number, jobDocumentId?: number): string {
		return `${jobId}_${documentId}_${jobDocumentId ?? 'none'}`;
	}

	public getDocumentUniqueKeyByDocument(document: BinderDocumentDetails): string {
		return this.getDocumentUniqueKey(document.jobId, document.documentId, document.jobDocumentId);
	}

	public onDocumentNotSupported(document: DocViewerDocumentDetails): void {
		this.documentDetailsCache.get(this.getDocumentUniqueKey(document.jobId, document.documentId, document.jobDocumentId)).isNotSupported = true;
	}

	public onAddToBinderClick(): void {
		if ((this.hasWorkToDoJob === null && !this.isBinderAndCustomerLegacy) || (!this.hasBinderUserPermission && this.isBinderAndCustomerLegacy)) {
			this.binderRequestAccess.open();
		} else {
			this.router.navigate([`digital-logbooks`], { relativeTo: this.activatedRoute });
			sessionStorage.setItem('binder-rurl', this.returnUrl);
		}
	}

	public initBinderSelection(): void {
		this.unsubscriber$.next();
		this.isDataLoading = true;
		this.isDocumentsLoadingFailed = false;
		this.loaderMessage = null;

		const year = this.binderFormGroup.get('year').value;
		const binderFilter: BinderFilter = {year};

		if (this.expectationTagsMap === undefined) {
			binderFilter.includeExpectationTags = true;
		}

		const token = TokenHelper.getToken(this.activatedRoute);

		forkJoin({
			binderContent: this.binderService.getBinderClassificationDocuments(token, binderFilter),
			documentTypes: this.binderService.getBinderDocumentTypes(token)
		})
		.pipe(takeUntil(this.unsubscriber$))
		.subscribe(
			({binderContent, documentTypes }) => {
				this.binderContent = binderContent;
				this.documentTypes = documentTypes;
				this.updateDocumentTypeRelatedData(token);
				this.mapBinderContent(binderContent);
				this.isDataLoading = false;
			},
			() => {
				this.isDocumentsLoadingFailed = true;
				this.isDataLoading = false;
				this.loaderMessage = "We could not load the documents";
			}
		);
	}

	private updateDocumentTypeRelatedData(token: string, selectedDocumentTypeIds: number[] = []): void {
		const documentTypeIds = selectedDocumentTypeIds.length > 0
			? selectedDocumentTypeIds
			: this.documentTypes.filter(dt => dt.hasMeasurements).map(dt => dt.documentTypeId);
		this.getReadingMeasurements(token, documentTypeIds, this.commonReadingsOnly);
		this.getNormalizationFieldExceptionCriterias();
	}

	public refreshSelection(): void {
		const parent: BinderClassification =
			this.binderFormGroup.get("parent").value;
		if (!parent) {
			this.selectedBinder = null;
			return;
		}

		if (parent.documents?.length) {
			if (parent.children.length) {
				this.binderFormGroup
					.get("child")
					.setValue(this.selectedBinderChildren[0]);
			} else {
				this.binderFormGroup.get("child").setValue(null);
			}
		} else {
			this.binderFormGroup
				.get("child")
				.setValue(this.selectedBinderChildren[0]);
		}
	}

	public loadDocument(
		index: number,
		loadNext = true,
		isMainDocument: boolean = true
	): void {
		if (
			!this.selectedBinder ||
			index < 0 ||
			index >= this.selectedBinder.documents.length
		) {
			return;
		}

		if (isMainDocument) {
			if (this.prevButton) {
				this.prevButton.style.color = "#e2e2e2";
				this.prevButton.style.cursor = "not-allowed";
				this.prevButton.disabled = true;
			}

			if (this.nextButton) {
				this.nextButton.style.color = "#e2e2e2";
				this.nextButton.style.cursor = "not-allowed";
				this.nextButton.disabled = true;
			}

			this.selectedDocumentDetailsIndex = index;

			this.cdRef.detectChanges();

			if (this.isSession) {
				const doc = this.selectedBinder.documents[index];
				const key = this.getDocumentUniqueKeyByDocument(doc);
				const cached = this.documentDetailsCache.get(key);

				if (cached && !cached.isLoading && !cached.isNotExisting) {
					this.trackBinderSessionDocumentView(doc.documentId);
				} 
			}

		}

		const document = this.selectedBinder.documents[index];

		if (!this.documentDetailsCache.get(this.getDocumentUniqueKeyByDocument(document))) {
			this.documentDetailsCache.set(this.getDocumentUniqueKeyByDocument(document), {
				documentId: document.documentId,
				documentDownloadName: document.downloadFileName,
				documentDisplayName: document.displayFileName,
				downloadDocumentId: document.downloadDocumentId,
				fileName: document.fileName,
				content: null,
				isLoading: true,
				isNotExisting: false,
				isNotSupported: false,		
				jobDocumentId: document.jobDocumentId,		 
				jobId: document.jobId
			});

			this.binderService
				.getJobDocument(
					TokenHelper.getToken(this.activatedRoute),
					document.documentId
				)
				.pipe(takeUntil(this.unsubscriber$))
				.subscribe(
					(blob) => {
						this.documentDetailsCache.get(this.getDocumentUniqueKeyByDocument(document)).content = blob;
						this.documentDetailsCache.get(this.getDocumentUniqueKeyByDocument(document)).isLoading =
							false;
						if (this.isSession && isMainDocument) {
							this.trackBinderSessionDocumentView(document.documentId);							
						}
					},
					() => {
						this.documentDetailsCache.get(this.getDocumentUniqueKeyByDocument(document)).isLoading =
							false;
						this.documentDetailsCache.get(this.getDocumentUniqueKeyByDocument(document)).isNotExisting =
							true;
					},
					() => {
						if (index === this.selectedDocumentDetailsIndex) {
							this.checkPrevButtonDisabledStatus();
							this.checkNextButtonDisabledStatus();
							this.checkDownloadButtonDisableStatus();
						}

						this.cdRef.detectChanges();
					}
				);
		} else {
			if (
				index === this.selectedDocumentDetailsIndex &&
				this.documentDetailsCache.get(this.getDocumentUniqueKeyByDocument(document)).isLoading === false
			) {
				this.checkPrevButtonDisabledStatus();
				this.checkNextButtonDisabledStatus();
				this.checkDownloadButtonDisableStatus();
				this.cdRef.detectChanges();
			}
		}

		if (loadNext) {
			this.loadDocument(index + 1, false, false);
		}
	}

	private trackBinderSessionDocumentView(documentId: number): void {
		this.binderService.trackBinderSessionDocumentView({
			token: TokenHelper.getToken(this.activatedRoute),
			urlHashActionTypeId: 37, // BinderSessionDocumentView
			documentId: documentId,
			parentTabId: this.binderFormGroup.get('parent')?.value?.binderClassificationId,
			childTabId: this.binderFormGroup.get('child')?.value?.binderClassificationId
		}).subscribe();
	}

	private getReadingMeasurements(token: string, documentTypeIds: number[], commonReadingsOnly: boolean): void {
		this.isDataLoading = true;
		if (documentTypeIds.length > 0 ){
			this.binderService.getBinderReadingsMeasurements(token, documentTypeIds, commonReadingsOnly)
				.pipe(takeUntil(this.unsubscriber$))
				.subscribe(
					readingMeasurements => {
					this.readingMeasurements = readingMeasurements;
					this.isMeasurementAvailable = readingMeasurements.length > 0;
					this.isDataLoading = false;
					},
					() => {
						this.isMeasurementAvailable = false;
						this.isDataLoading = false;
					}
				);
		}
	}

	private getNormalizationFieldExceptionCriterias(): void {
		if (this.documentTypes.length > 0 ){
			this.binderService.getNormalizationFieldExceptionCriterias()
				.pipe(takeUntil(this.unsubscriber$))
				.subscribe(
					normalizationFieldExceptionCriterias => {
						this.normalizationFieldExceptionCriterias = normalizationFieldExceptionCriterias;
					});
		}
	}

	private filterReadingCriteria(): void {
		if (!this.selectedMeasurement || this.selectedMeasurement?.serviceCategoryDocumentReadingId === 0) {
			this.readingCriterias = [];
			this.selectedCriteria = null;
			return;
		}

		if (this.selectedMeasurement.readingDataTypeId === ReadingDataType.Decimal || this.selectedMeasurement.readingDataTypeId === ReadingDataType.Integer) {
			this.readingCriterias = this.normalizationFieldExceptionCriterias.filter(c => c.dataType === NormalizationFieldExceptionCriteriaDataType.Numeric);
		} else if (this.selectedMeasurement.readingDataTypeId === ReadingDataType.Text) {
			this.readingCriterias = this.normalizationFieldExceptionCriterias.filter(c => c.dataType === NormalizationFieldExceptionCriteriaDataType.String);
		} else if (this.selectedMeasurement.readingDataTypeId === ReadingDataType.TAG) {
			this.readingCriterias = this.normalizationFieldExceptionCriterias.filter(c => c.dataType === NormalizationFieldExceptionCriteriaDataType.Boolean
				// skip value required criteria for TAG readings
				&& !c.isValueRequired
			);
		} else {
			this.readingCriterias = [];
		}
		const exceptionCriteria = this.readingCriterias.find(x => x.criteria === 'any') || null;
		this.filterBinderForm.patchValue({ readingCriteria: exceptionCriteria });
		this.selectedCriteria = exceptionCriteria;
	}

	public onMeasurementChange(selectedMeasurement: ReadingMeasurement): void {
		this.selectedMeasurement = selectedMeasurement;
		this.serviceCategoryDocumentReadingId = this.selectedMeasurement?.serviceCategoryDocumentReadingId;
		this.resetReadingFields();
		this.filterReadingCriteria();
	}

	public isNumericCriteria(): boolean {
		return (
			this.selectedMeasurement.readingDataTypeId === ReadingDataType.Decimal ||
			this.selectedMeasurement.readingDataTypeId === ReadingDataType.Integer
		);
	}

	public updateReadingValue(selectedCriteria: NormalizationFieldExceptionCriteria): void {
		this.selectedCriteria = selectedCriteria;
		if (selectedCriteria.isRangeValue) {
			this.filterBinderForm.get('readingValueStart')?.setValidators(Validators.required);
			this.filterBinderForm.get('readingValueEnd')?.setValidators(Validators.required);
			this.filterBinderForm.get('readingValue')?.clearValidators();

			this.filterBinderForm.get('readingValue')?.setValue(null);
		} else {
			this.filterBinderForm.get('readingValueStart')?.clearValidators();
			this.filterBinderForm.get('readingValueEnd')?.clearValidators();

			if (!selectedCriteria.isValueRequired) {
				this.filterBinderForm.get('readingValue')?.clearValidators();
			} else {
				this.filterBinderForm.get('readingValue')?.setValidators(Validators.required);
			}

			this.filterBinderForm.get('readingValueStart')?.setValue(null);
			this.filterBinderForm.get('readingValueEnd')?.setValue(null);
		}
	}

	private checkPrevButtonDisabledStatus(): void {
		if (this.prevButton) {
			if (!this.disablePrevDocButton) {
				this.prevButton.style.color = "#121FDF";
				this.prevButton.style.cursor = "pointer";
				this.prevButton.disabled = false;
			} else {
				this.prevButton.style.color = "#e2e2e2";
				this.prevButton.style.cursor = "not-allowed";
				this.prevButton.disabled = true;
			}
		}
	}

	private checkNextButtonDisabledStatus(): void {
		if (this.nextButton) {
			if (!this.disableNextDocButton) {
				this.nextButton.style.color = "#121FDF";
				this.nextButton.style.cursor = "pointer";
				this.nextButton.disabled = false;
			} else {
				this.nextButton.style.color = "#e2e2e2";
				this.nextButton.style.cursor = "not-allowed";
				this.nextButton.disabled = true;
			}
		}
	}

	private checkDownloadButtonDisableStatus(): void {
		if (this.downloadButton) {
			if (!this.disableDownloadDocButton) {
				this.downloadButton.style.color = "#121FDF";
				this.downloadButton.style.cursor = "pointer";
				this.downloadButton.disabled = false;
			} else {
				this.downloadButton.style.color = "#e2e2e2";
				this.downloadButton.style.cursor = "not-allowed";
				this.downloadButton.disabled = true;
			}
		}
	}

	public get disablePrevDocButton(): boolean {
		return (
			this.selectedDocumentDetailsIndex <= 0 ||
			this.selectedBinder.documents.length <= 1
		);
	}

	public get disableNextDocButton(): boolean {
		return (
			this.selectedDocumentDetailsIndex >=
			this.selectedBinder.documents.length - 1 ||
			this.selectedBinder.documents.length <= 1
		);
	}

	public get disableDownloadDocButton(): boolean {
		return !this.selectedDocument || this.selectedBinder.documents.length === 0;
	}

	public downloadCurrentDocument(): void {
		const document = this.selectedDocument;
		this.binderService
			.getJobDocument(
				TokenHelper.getToken(this.activatedRoute),
				document.downloadDocumentId
			)
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((blob) => {
				saveAs(blob, document.documentDownloadName);
			});
	}

	public afterWebViewerRender(instance): void {
		instance.setHeaderItems((header) => {
			this.setHeaderElements(header);
		});

		const interval = setInterval(() => {
			if (!this.docViewerHeaderReady) return;
			this.checkPrevButtonDisabledStatus();
			this.checkNextButtonDisabledStatus();
			this.checkDownloadButtonDisableStatus();
			this.cdRef.detectChanges();
			clearInterval(interval);
		}, 100);
	}

	public setHeaderElements(header) {
		this.docViewerHeaderReady = false;
		const items: any[] = header.getItems();
		const buttonPadding = GlobalUtilsService.isMobileDevice ? "0 7px" : "0 10px"
		this.customButtons = [
			{
				type: "customElement",
				dataElement: "customPreviousDocButton",
				render: () => {
					const btn = document.createElement("button");
					btn.innerHTML = "Previous";

					btn.style.fontSize = "18px";
					btn.style.fontWeight = "700";
					btn.style.fontFamily = "Segoe UI";
					btn.style.border = "none";
					btn.style.background = "transparent";
					btn.style.padding = buttonPadding;
					btn.style.textDecoration = 'underline';
					btn.style.color = "#e2e2e2";
					btn.style.cursor = "not-allowed";
					btn.disabled = true;

					btn.onclick = () => {
						this.loadDocument(this.selectedDocumentDetailsIndex - 1);
					};

					this.prevButton = btn;

					return btn;
				},
			},
			{
				type: "customElement",
				dataElement: "customNextDocButton",
				render: () => {
					const btn = document.createElement("button");
					btn.innerHTML = "Next Document";

					btn.style.fontSize = "18px";
					btn.style.fontWeight = "700";
					btn.style.fontFamily = "Segoe UI";
					btn.style.border = "none";
					btn.style.background = "transparent";
					btn.style.padding = buttonPadding;
					btn.style.textDecoration = 'underline';
					btn.style.color = "#e2e2e2";
					btn.style.cursor = "not-allowed";
					btn.disabled = true;

					btn.onclick = () => {
						this.loadDocument(this.selectedDocumentDetailsIndex + 1);
					};

					this.nextButton = btn;

					return btn;
				},
			},
		];
		if (this.binderDetails.isDocumentDownloadEnabled) {
			this.customButtons.push({
				type: "customElement",
				dataElement: "customDownloadDocButton",
				render: () => {
					const downloadButton = document.createElement("button");
					downloadButton.innerHTML = "Download";

					downloadButton.style.fontSize = "18px";
					downloadButton.style.fontWeight = "700";
					downloadButton.style.fontFamily = "Segoe UI";
					downloadButton.style.border = "none";
					downloadButton.style.background = "transparent";
					downloadButton.style.padding = buttonPadding;
					downloadButton.style.textDecoration = 'underline';
					downloadButton.style.color = "#e2e2e2";
					downloadButton.style.cursor = "not-allowed";
					downloadButton.disabled = true;

					downloadButton.onclick = () => {
						this.downloadCurrentDocument();
					};

					this.downloadButton = downloadButton;
					return downloadButton;
				},
			});
		}
		const toolbarItems = [...this.customButtons, ...items];		
		header.update(toolbarItems);
		this.docViewerHeaderReady = true;
	}

	private mapBinderContent(content: BinderContent): void {
		const documents = new Map<number, BinderDocumentDetails>();
		const classificationTree = new Map<number, BinderClassification[]>();
		const binderTabs = new Map<number, BinderTabContent>();
		const jobs = content.jobs;

		if (this.expectationTagsMap === undefined) {
			this.expectationTagsMap = new Map<number, BinderExpectationTag[]>();

			content.resources.forEach((resource) => {
				this.expectationTagsMap.set(resource.accountSiteResourceId, resource.expectationTags)
			});
		}

		content.tabs.forEach((item) =>
			binderTabs.set(item.binderClassificationId, item)
		);
		content.documents = content.documents.map((item) => ({ item, job: jobs.find(job => job.jobId === item.jobId) })).map(({ item, job }) => ({ ...item, ...job }));

		content.documents.forEach((item) => documents.set(item.documentId, item));

		this.binderClassification.forEach((item) => {
			item.documents =
				binderTabs
					.get(item.binderClassificationId)
					?.documents.map((tabDocument) => documents.get(tabDocument.documentId)) || [];
		});

		this.binderParents = this.binderClassification.filter(
			(item) => !item.parentBinderClassificationId
		);

		this.binderParents.forEach((item) =>
			classificationTree.set(item.binderClassificationId, [])
		);

		this.binderClassification.forEach((item) => {
			if (
				item.parentBinderClassificationId &&
				classificationTree.has(item.parentBinderClassificationId) &&
				item.documents?.length
			) {
				classificationTree.get(item.parentBinderClassificationId).push(item);
			}
		});

		this.binderParents.forEach((item) => {
			item.children = classificationTree.get(item.binderClassificationId);
		});

		this.binderParentsCopy = JSON.parse(JSON.stringify(this.binderParents));

		if ( this.filterBinderForm.get('fromDate').value === null &&
			this.filterBinderForm.get('toDate').value === null) {
			this.documentAssets = content.resources;
			if (!this.binderDetails?.accountSiteResourceId && !this.binderDetails?.accountSiteResourceName) {
				this.documentAssets.unshift({ accountSiteResourceId: 0, expectationTags: null, isDeComissioned: false, isSeasonal: false, name: '- any asset -' });
			} else {
				this.filterBinderForm.patchValue({ asset: this.documentAssets[0].accountSiteResourceId });
			}
		}
		this.filterBinder(this.filterBinderForm.get('showTabs').value, this.filterBinderForm.get('asset')?.value);
	}

	private checkAddToBinderAccess(): void {
		this.binderService
			.getBinderUserAccess(TokenHelper.getToken(this.activatedRoute))
			.subscribe(
				(result) => (this.hasAddToBinderAccess = result.hasAddToBinderAccess),
				() => (this.hasAddToBinderAccess = false)
			);
	}

	public openSendDocumentationModal(): void {
		this.sendDocumentation.open();
	}

	public openQRScansHistory(): void {
		this.qrScanHistory.open();
	}

	private checkEditBinderAccess(): void {
		this.binderService
			.hasEditBinderAccess(TokenHelper.getToken(this.activatedRoute))
			.subscribe(
				(result) => (this.hasEditBinderAccess = result),
				() => (this.hasEditBinderAccess = false)
			);
	}

	public openEditBinderModal(): void {
		this.editBinder.open();
	}

	public initFilterBinderForm(): void {
		this.filterBinderForm = new FormGroup({
			showTabs: new FormControl(true),
			hideReviewRequired: new FormControl(false),
			asset: new FormControl(0),
			documentTypes: new FormControl([]),
			measurements: new FormControl( []),
			fromDate: new FormControl(null),
			toDate: new FormControl(null),
			readingCriteria: new FormControl(null),
			readingValueStart: new FormControl(null),
			readingValueEnd: new FormControl(null),
			readingValue: new FormControl(null),
			expectationAssetTagId: new FormControl(null)
		});

		this.filterBinderForm.get("asset").valueChanges.subscribe(() => {
			this.availableTags =  this.expectationTagsMap.get(this.filterBinderForm.get('asset').value);
			if(this.availableTags){
				var crtServiceContracts = [...new Set(this.availableTags.filter(et => et.expectationAssetTagId > 0).map(t => t.serviceContractName))];
				this.displayServiceContractName = crtServiceContracts.length > 1;
			}
		});
	}

	public filterBinder(showTabs: boolean, accountSiteResourceId?: number): void {
		this.binderParents = cloneDeep(this.binderParentsCopy);
		if (!!accountSiteResourceId && accountSiteResourceId !== 0 && !this.binderDetails.accountSiteResourceName) {
			this.binderParents.forEach((parent) => {
				parent.documents = parent.documents.filter((document) => document.accountSiteResourceId === accountSiteResourceId);
			});
		}

		if (showTabs) {
			this.binderParents = this.binderParents.filter(
				(item) => item.documents?.length || item.children?.length
			);
		}

		if (this.binderParents?.length) {
			this.binderFormGroup.get('parent').setValue(this.binderParents[0]);
		} else {
			this.selectedBinderChildren = [];
			this.selectedBinder = null;
		}
		this.isBinderFiltered = !!this.filterBinderForm?.get('fromDate')?.value || !!this.filterBinderForm?.get('toDate')?.value || !!this.filterBinderForm?.get('readingCriteria')?.value || !!this.filterBinderForm?.get('readingValue')?.value || this.filterBinderForm?.get('asset')?.value !== 0 || this.filterBinderForm?.get('showTabs')?.value === false;
	}

	public onFilterClick(): void {
		this.filterModal.open();
	}

	public onFilterCancel(): void {
		this.filterBinderForm.patchValue(this.filter);
		this.filterModal?.hide();
	}

	public filterData(): void {
		this.isDataLoading = true;

		const readingCriteria = this.selectedCriteria ? this.selectedCriteria.criteria : null;

		let readingValue = null;

		if (this.selectedCriteria) {
			const isCriteriaRange = this.selectedCriteria.isRangeValue;

			if (isCriteriaRange) {
				readingValue = [
					this.filterBinderForm.get('readingValueStart')?.value,
					this.filterBinderForm.get('readingValueEnd')?.value
				];
			} else {
				readingValue = this.filterBinderForm.get('readingValue')?.value;
			}
		}

		const documentTypeIds = this.filterBinderForm.get('documentTypes')?.value;

		const numericDocumentTypeIds = Array.isArray(documentTypeIds)
			? documentTypeIds.map(id => Number(id))
			: [];

		const binderFilter: BinderFilter = {
			year: this.binderFormGroup.get('year')?.value,
			fromDate: this.filterBinderForm.get('fromDate')?.value,
			toDate: this.filterBinderForm.get('toDate')?.value,
			hideReviewRequired: this.filterBinderForm.get('hideReviewRequired')?.value,
			serviceCategoryDocumentReadingId: this.serviceCategoryDocumentReadingId,
			documentTypeIds: numericDocumentTypeIds,
			readingCriteria,
			readingValue,
			expectationAssetTagId: this.filterBinderForm.get('expectationAssetTagId')?.value
		};

		this.binderService.getBinderClassificationDocuments(
			TokenHelper.getToken(this.activatedRoute),
			binderFilter
		).subscribe((content: BinderContent) => {
				this.binderContent = content;
				this.mapBinderContent(content);
				this.filter = {
					showTabs: this.filterBinderForm.get('showTabs')?.value,
					asset: this.filterBinderForm.get('asset')?.value,
					fromDate: this.filterBinderForm.get('fromDate')?.value,
					toDate: this.filterBinderForm.get('toDate')?.value,
					documentTypeIds: numericDocumentTypeIds,
					readingCriteria: this.filterBinderForm.get('readingCriteria')?.value,
					readingValue: this.filterBinderForm.get('readingValue')?.value,
					readingValueStart: this.filterBinderForm.get('readingValueStart')?.value,
					readingValueEnd: this.filterBinderForm.get('readingValueEnd')?.value
				};
				this.isDataLoading = false;
			}, () => this.isDataLoading = false,
			() => this.isDataLoading = false);

		this.filterModal?.hide();
	}



	public setFilterDates(): void {
		if (!this.binderDetails.isYearless) {
			this.minDate = new Date(this.binderFormGroup.get('year')?.value, 0, 1);
			this.maxDate = new Date(this.binderFormGroup.get('year')?.value, 11, 31);
			this.startDate = this.minDate;
		}
	}

	private resetReadingFields() {
		this.filterBinderForm.get('readingValue')?.clearValidators();
		this.filterBinderForm.get('readingValueStart')?.clearValidators();
		this.filterBinderForm.get('readingValueEnd')?.clearValidators();
		this.filterBinderForm.get('readingCriteria')?.patchValue(null);
		this.filterBinderForm.get('readingValue')?.patchValue(null);
		this.filterBinderForm.get('readingValueStart')?.patchValue(null);
		this.filterBinderForm.get('readingValueEnd')?.patchValue(null);
	}

	public onBackToBinderRequest(): void {
		this.router.navigate([this.binderDetails.redirectUri]);
	}

	public onExportFilesClick(): void {
		this.binderExportFilesWarning.open();
	}

	public onExportFilesConfirm(): void {
		this.exportBinderFiles = {} as BinderExportFiles;
		this.exportBinderFiles.templateName = this.binderDetails.binderName;
		this.exportBinderFiles.siteName = this.binderDetails.accountSiteName;
		this.exportBinderFiles.assetName = this.binderDetails.accountSiteResourceName;
		this.exportBinderFiles.siteId = this.binderDetails?.accountSiteId;
		this.exportBinderFiles.assetId = this.binderDetails?.accountSiteResourceId;
		this.exportBinderFiles.year = this.binderFormGroup.get('year')?.value;
		this.exportBinderFiles.documentTypes = this.documentTypes;
		this.exportBinderFiles.readingMeasurements = this.readingMeasurements;
		this.exportBinderFiles.measurementCriteria = this.measurementCriteria;

		if (!this.filterBinderForm.get('showTabs')?.value) {
			this.exportBinderFiles.documentTabs = cloneDeep(this.binderParents);
			this.exportBinderFiles.documentTabs = this.exportBinderFiles.documentTabs.filter(
				(item) => item.documents?.length || item.children?.length
			);
		} else {
			this.exportBinderFiles.documentTabs = this.binderParents;
		}

		this.binderService
			.exportBinderFiles(TokenHelper.getToken(this.activatedRoute), this.exportBinderFiles)
			.subscribe((res) => {

			});
		this.binderExportFilesWarning.hide();
	}

	public onDocumentTypeChange(opened: boolean): void {
		if (!opened) {
			this.selectedMeasurement = null;
			this.selectedCriteria = null;

			this.resetReadingFields();
			const selectedDocumentTypeIds = this.filterBinderForm.get('documentTypes')?.value;

			let docTypeIds: number[];
			this.commonReadingsOnly = false;

			if (selectedDocumentTypeIds.length === 0 || selectedDocumentTypeIds[0] === 0) {
				docTypeIds = this.documentTypes
					.filter(doc => doc.hasMeasurements)
					.map(doc => doc.documentTypeId);
				this.getReadingMeasurements(TokenHelper.getToken(this.activatedRoute), docTypeIds, this.commonReadingsOnly);
				return;
			}

			docTypeIds = selectedDocumentTypeIds.filter(selectedId =>
				this.documentTypes.some(docType =>
					docType.documentTypeId === selectedId
				)
			);

			if (docTypeIds.length === 0) {
				this.isMeasurementAvailable = false;
				return;
			}

			this.isMeasurementAvailable = true;
			this.commonReadingsOnly = true;
			this.getReadingMeasurements(TokenHelper.getToken(this.activatedRoute), docTypeIds, this.commonReadingsOnly);

			const measurementControl = this.filterBinderForm.get('measurements');
			if (measurementControl) {
				measurementControl.reset();
				measurementControl.enable();
			}
		}
	}

	get selectedTag(){
		let expectationAssetTagId = this.filterBinderForm.get('expectationAssetTagId')?.value;
		if(!!expectationAssetTagId){
			let tag = this.availableTags.find(t => t.expectationAssetTagId === expectationAssetTagId);
			return !!tag ? tag.tag : undefined;
		}

		return expectationAssetTagId;
	}

}
